import { TasksTestID } from "@/constants/TestID";
import { Text } from "@/ui/core";
import { VStack } from "@/ui/layout";
import CheckSVG from "@/ui/theme/icons/illustrations/CheckSVG";
import { joinTestIDs } from "@/utils/string.util";

enum TaskEmptyStateContent {
  Subtitle = "Thanks for doing your part, we appreciate it!",
  Title = "All to-dos completed",
}

const TasksEmptyState = () => {
  const baseTestID = TasksTestID.TasksEmptyState;

  return (
    <VStack alignItems="center" gap={2} height={87} justifyContent="center">
      <CheckSVG height={46} width={46} />
      <Text
        accessibilityLabel="All to-dos completed"
        testID={joinTestIDs(baseTestID, "title")}
        variant="bodyMedium"
      >
        {TaskEmptyStateContent.Title}
      </Text>
      <Text
        accessibilityLabel="All to-dos completed"
        testID={joinTestIDs(baseTestID, "subtitle")}
        variant="caption"
      >
        {TaskEmptyStateContent.Subtitle}
      </Text>
    </VStack>
  );
};

export { TaskEmptyStateContent };
export default TasksEmptyState;
